import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'collections-add_collection_to_cart-click';
/**
 * Track FB Pixel and GTM for add collection to cart events
 */
export function trackCollectionsAddCollectionToCartClick(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'AddToCartCollection',
        googleTagManagerEvent: 'AddToCartCollection',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
